/*eslint-disable*/
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Images
import bgFront from "assets/images/rotating-card-bg-front.jpeg";
import bgBack from "assets/images/rotating-card-bg-back.jpeg";

function Information() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="touch_app"
                title={
                  <>
                    Mes principales expertises
                  </>
                }
                description="Des compétences polyvalentes et concrètes, développées à travers mes expériences en développement logiciel, SIG, design et gestion de projets numériques."
              />
              <RotatingCardBack
                image={bgBack}
                title="Découvrez mes compétences"
                description="Cliquez pour explorer mes expertises en développement logiciel, SIG, design et gestion de projets numériques à travers mes réalisations et expériences."
                action={{
                  type: "internal",
                  route: "/realisation", // lien vers la section de tes compétences détaillées
                  label: "Voir mes réalisations",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="code"
                  title="Développement web et mobile"
                  description="Conception et maintenance d’applications web et mobiles, développement de logiciels et intégration 
                  d’outils numériques pour la digitalisation des opérations."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="layers"
                  title="Système d’Information Géomatique"
                  description="Analyse spatiale, cartographie et télédétection, géolocalisation GPS et suivi terrain, gestion et sécurisation des bases de données SIG,
                   ainsi que conception de cartes thématiques et de rapports pour appuyer la prise de décision."
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="brush"
                  title="Design et communication digitale"
                  description="Création d’identités visuelles, design graphique, communication visuelle,comunity manager , 
                  développement de sites vitrines multilingues et optimisation de l’expérience utilisateur (UX/UI)."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="work"
                  title="Gestion de projets et leadership technologique"
                  description="Pilotage de la stratégie informatique et des projets numériques en utilisant les méthodologies PMBOK, Scrum et Agile,
                   coordination des équipes et prise de décisions pour garantir la performance et la sécurité des systèmes."
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
